import React, { useState } from 'react';

const YoutubeVideo = ({ videoId }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  return isLoaded ? (
    <iframe
      src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
      width="100%"
      style={{ border: "none", height: "300px", display: "block" }}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="YouTube Video"
    ></iframe>
  ) : (
    <div
      className="video-thumbnail"
      onClick={() => setIsLoaded(true)}
      style={{
        backgroundImage: `url(https://img.youtube.com/vi/${videoId}/maxresdefault.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '300px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        position: 'relative',
        backgroundColor: 'var(--line)'
      }}
    >
      <div className="play-button">▶</div>
    </div>
  );
};

export default YoutubeVideo;
